import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import { isEmpty } from "lodash";
import { useContext } from "react";
import { tokens } from "styles/Tokens";
import Chip from "./Chip";
import Typography from "./Typography";

interface Props {
  logo?: any;
  label?: string;
  progressChip?: any;
  value?: any;
  prevalue?: string;
  sx?: object;
  coloredScore?: any;
  showMetricScore?: boolean;
}

function InfoBar(props: Readonly<Props>) {
  const { logo, label, progressChip, value, coloredScore, sx, showMetricScore = false } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <Box
      className="info-bar"
      component="div"
      sx={{
        display: "flex",
        bgcolor: tokens.Background.General.Secondary,
        borderRadius: "8px",
        padding: "12px",
        flexDirection: isMobileScreen ? "column" : "row",
        alignItems: "center",
        minHeight: "45px",
        height: "auto",
        gap: "4px",
        ...sx
      }}
    >
      {logo && (
        <Box marginTop="5px" sx={{ display: "flex", flexDirection: "row", gap: "4px" }}>
          <Typography> {logo}</Typography>
          <Typography variant={isMobileScreen ? "label" : "body2"} changeVariant={false}>
            {label}
          </Typography>
        </Box>
      )}

      <Box sx={{ display: "flex", flexDirection: isMobileScreen ? "column" : "row", gap: "4px", ...sx }}>
        {!logo && (
          <Typography variant={isMobileScreen ? "label" : "body2"} changeVariant={false} sx={{ alignSelf: "center" }}>
            {label}
          </Typography>
        )}
        {value && (
          <Typography
            component="span"
            variant={isMobileScreen ? "label" : "body2"}
            changeVariant={false}
            showBold
            sx={{ alignSelf: "center" }}
          >
            {value}
          </Typography>
        )}
        {showMetricScore && <Typography>{coloredScore}</Typography>}
      </Box>
      {!isEmpty(progressChip) && (
        <Box marginLeft={"6px"}>
          <Chip
            backgroundColor={progressChip?.backgroundColor}
            color={progressChip?.color ? progressChip?.color : tokens.Text.General.Inverse}
            label={progressChip?.label}
            size={isMobileScreen ? "small" : "medium"}
            borderColor={progressChip?.borderColor ? progressChip?.borderColor : "none"}
            icon={progressChip?.icon}
            iconAtStart={progressChip?.iconAtStart}
          ></Chip>
        </Box>
      )}
      {isEmpty(progressChip) && coloredScore && <Typography className="metric-score">{coloredScore}</Typography>}
    </Box>
  );
}

export default InfoBar;
